// api/getDeliveryRates.js

export const getUpdatedDeliveryRate = async (carrierId) => {
  try {
    const raw = JSON.stringify({
      jsonrpc: "2.0",
      method: "call",
      params: {
        carrier_id: carrierId,
      },
    });

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: raw,
    };
    const endpoint = "/shop/update_carrier";
    const fullUrl = `${window.location.origin}${endpoint}`;
    const response = await fetch(fullUrl, requestOptions);

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching delivery rates:", error);
    throw error;
  }
};
